import { Component } from '@grafikr/components';

import Cart from 'utils/cart';
import { NonNullish } from 'utils/nullish-check';

export default Component((node, { onMounted }) => {
  const config = JSON.parse(node.querySelector('[data-config]')?.textContent ?? '{}');
  const parent = NonNullish(node.parentElement);
  const toggle = NonNullish(node.querySelector<HTMLButtonElement>('[data-hide]'));
  const autoplay = node.dataset.autoplay === 'true';
  const interval = Number(node.dataset.interval) * 1000;

  const announcements = Array.from(node.querySelectorAll<HTMLElement>('[data-announcement]'));

  const close = () => {
    parent.remove();

    const data = new FormData();
    data.append(`attributes[${config.key}]`, 'true');

    Cart.update(data);
  };

  const updateVariables = () => {
    document.documentElement.style.setProperty('--announcement-height', `${parent.clientHeight}px`);
  };

  const startAutoplay = (delay = 5000) => {
    setInterval(() => {
      const currentIndex = announcements.findIndex(
        (announcement) => !announcement.classList.contains('opacity-0'),
      );

      const nextIndex = (currentIndex + 1) % announcements.length;

      announcements.forEach((announcement) =>
        announcement.classList.add('opacity-0', 'pointer-events-none'),
      );
      const nextAnnouncement = NonNullish(announcements[nextIndex]);
      setTimeout(() => nextAnnouncement.classList.remove('opacity-0', 'pointer-events-none'), 300);
    }, delay);
  };

  onMounted(() => {
    toggle.addEventListener('click', close);

    if (window.ResizeObserver) {
      const observer = new ResizeObserver(updateVariables);
      observer.observe(node);
    }

    if (autoplay) startAutoplay(interval);
  });
});
